import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { addSettings, setLeftMenu } from "../../../actions";
import {
  ListSubUserRoles,
  ListSubUserSubRoles,
  setSequenceNo,
  setSequenceNoSub,
  listSubUserPermissions,
  updateUserPermissions,
  getSubUserMenuGroups,
  getAttachedMenuItem,
  deleteMenuGroup,
  assignRolesToGroup,
  setDefault,
  unsetDefault,
} from "../../../config/general_api_calls";
import { resellerLeftMenu } from "../../../config/api_calls";
import $ from "jquery";
import DataTable from "../../../components/Tables/DataTable";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "../../../config/helperClass";
import { THEME_TEXT_COLOR, THEME_COLOR } from "../../../config/config";
import Tooltip from "@material-ui/core/Tooltip";
import Checkbox from "@material-ui/core/Checkbox";
import UserPermissionHelper from "../../../components/Reseller/UserPermissionHelper";

const auth = new HelperClass();

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class SubUserRoles extends Component {
  constructor() {
    super();
    this.state = {
      listRoleData: [],
      listSubRoleData: [],
      listPermissionRoles: [],
      listPermissionSubRoles: [],
      listPermissionData: [],
      errorMessage: "",
      successMessage: "",
      title: "",
      name: "",
      logo: "",
      delete_id: "",
      description: "",
      tableLoader: true,
      domain: "",
      step: 1,
      subRoleColumns: [],
      menuGroupColumns: [],

      isEditing: null,
      menuSequences: {},
      sequenceNo: "",
      roleId: "",
      errorMessageMatch: "",
      successMessageMatch: "",

      isEditingSub: null,
      menuSequencesSub: {},
      sequenceNoSub: "",
      roleIdSub: "",
      errorMessageMatchSub: "",
      successMessageMatchSub: "",
      roles_button: false,
      permissionErrorMsg: "",
      permissionSuccessMsg: "",

      subUserMenuTab: localStorage.getItem("subUserMenuTab") || "main_menu",
      listMenuGroupData: [],
      listAttachMenuData: [],
      selected_group_id: "",
      errorMessageAttach: "",
      successMessageAttach: "",
      attach_group: [],
      groupTitle: "",
      errorMessageDefault: "",
      successMessageDefault: "",
      permissionsState: [],
      permission_add_group: 0,
      permission_edit_group: 0,
      permission_delete_group: 0,
      permission_make_default: 0,
      permission_edit_main_menu: 0,
      permission_edit_sub_menu: 0,
      permission_save_permissions: 0,

      searchTerm: "",

      rolecolumns: [
        { name: "Title" },
        { name: "Link" },
        { name: "Menu Icon" },
        {
          name: "Menu Sequence",
          options: {
            customBodyRender: (value, tableMeta) => {
              return (
                <div>
                  {this.state.isEditing === tableMeta.rowIndex ? (
                    <div className="flex items-center">
                      <input
                        type="text"
                        value={
                          this.state.menuSequences[tableMeta.rowIndex] ?? value
                        }
                        onChange={(e) =>
                          this.handleMenuSequenceChange(e, tableMeta.rowIndex)
                        }
                        onInput={(e) => {
                          let value = e.target.value.replace(/[^0-9]/g, "");
                          if (value.length === 1) {
                            value = value.replace(/[0]/g, "");
                          }
                          if (
                            value !== "" &&
                            parseInt(value) > 0 &&
                            parseInt(value) <= 99
                          ) {
                            e.target.value = value;
                          } else if (value === "") {
                            e.target.value = "";
                          } else {
                            e.target.value = e.target.previousValue || "";
                          }
                          e.target.previousValue = e.target.value;
                        }}
                        className="w-8 mr-2 p-1 text-center"
                        maxLength="2"
                        disabled={this.state.isSaving}
                      />
                      <Tooltip title="Save" placement="top">
                        <span
                          className="mr-2 text-primary"
                          onClick={() =>
                            this.handleSaveClick(
                              tableMeta.rowIndex,
                              tableMeta.rowData[7],
                            )
                          }
                          style={{
                            cursor: this.state.isSaving ? "default" : "pointer",
                            fontSize: "17px",
                            opacity: this.state.isSaving ? "0.5" : "1",
                            pointerEvents: this.state.isSaving
                              ? "none"
                              : "auto",
                          }}
                        >
                          <em className="icon ni ni-save "></em>
                        </span>
                      </Tooltip>

                      {!this.state.isSaving && (
                        <Tooltip title="Close" placement="top">
                          <span
                            onClick={() => this.handleCancelEdit()}
                            style={{ cursor: "pointer", fontSize: "17px" }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </span>
                        </Tooltip>
                      )}
                    </div>
                  ) : (
                    <div>
                      {value}{" "}
                      <Tooltip title="Edit" placement="top">
                        <span
                          className="mr-1"
                          onClick={() =>
                            this.handleEditClick(tableMeta.rowIndex, value)
                          }
                          style={{
                            cursor: "pointer",
                            fontSize: "13px",
                          }}
                        >
                          <em className="icon ni ni-edit"></em>
                        </span>
                      </Tooltip>
                    </div>
                  )}
                </div>
              );
            },
          },
        },
        {
          name: "Status",
          options: {
            customBodyRender: (value, tableMeta) => {
              return <div>{this.roleStatus(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Default Tab",
          options: {
            customBodyRender: (value, tableMeta) => {
              return <div>{this.roleDefault(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "For Sub User",
          options: {
            customBodyRender: (value, tableMeta) => {
              return <div>{this.roleStatusForSub(value, tableMeta)}</div>;
            },
          },
        },
        { name: "ID", options: { display: false } },
        // {
        //   name: "Actions",
        //   options: {
        //     customBodyRender: (value, tableMeta) => {
        //       return (
        //         <div>
        //           <div
        //             className="nk-tb-col nk-tb-col-tools"
        //             style={{ padding: "0px" }}
        //           >
        //             <ul className="nk-tb-actions gx-1">
        //               <li>
        //                 <div className="drodown">
        //                   <a
        //                     href="#"
        //                     className="dropdown-toggle btn btn-icon btn-outline-light"
        //                     data-toggle="dropdown"
        //                   >
        //                     <em className="icon ni ni-more-h"></em>
        //                   </a>
        //                   <div className="dropdown-menu dropdown-menu-right">
        //                     <ul className="link-list-opt no-bdr">
        //                       <li>
        //                         <a
        //                           data-toggle="tooltip"
        //                           data-placement="left"
        //                           onClick={() =>
        //                             this.addMenuHistory(
        //                               "/admin_roles/edit_role/" +
        //                                 tableMeta.rowData[7]
        //                             )
        //                           }
        //                           title="Edit Menu Item"
        //                           style={{ cursor: "pointer" }}
        //                         >
        //                           <em className="icon ni ni-edit"></em>
        //                           <span>Edit Menu Item</span>
        //                         </a>
        //                       </li>
        //                     </ul>
        //                   </div>
        //                 </div>
        //               </li>
        //             </ul>
        //           </div>
        //         </div>
        //       );
        //     },
        //   },
        // },
        {
          name: "Actions",
          label: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              const isDisabled =
                this.props.is_msa_signed === "No" ||
                this.props.defaultSettings === "missing";

              const disabledMsg =
                "Action disabled because MSA is not signed or default settings are missing.";

              return (
                <>
                  {this.state.permissionsState &&
                  this.state.permissionsState.length > 0 &&
                  this.state.permission_edit_main_menu === 1 ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        minHeight: 36,
                      }}
                    >
                      {/* Edit Menu Item */}
                      <Tooltip
                        title={isDisabled ? disabledMsg : "Edit Menu Item"}
                        placement="top"
                      >
                        <span
                          role="button"
                          tabIndex={0}
                          aria-disabled={isDisabled}
                          onClick={() => {
                            if (!isDisabled) {
                              this.addMenuHistory(
                                "/admin_roles/edit_role/" +
                                  tableMeta.rowData[7],
                              );
                            }
                          }}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            cursor: isDisabled ? "not-allowed" : "pointer",
                            opacity: isDisabled ? 0.3 : 1,
                          }}
                        >
                          <em
                            className="icon ni ni-edit text-primary"
                            style={{ fontSize: 18 }}
                          />
                        </span>
                      </Tooltip>

                      {/* You can add more actions here if needed */}
                    </div>
                  ) : (
                    "---"
                  )}
                </>
              );
            },
          },
        },
      ],
      tableData: [],
    };
  }

  async componentDidMount() {
    const savedTab = localStorage.getItem("subUserMenuTab") || "main_menu";
    this.setState({ tableLoader: true, subUserMenuTab: savedTab });

    try {
      if (savedTab === "sub_menu") {
        await this.getSubUserSubRoles();
        this.setState({ tableLoader: false });
      } else if (savedTab === "subadmin_roles") {
        await this.getSubUserPermissions();
        this.setState({ tableLoader: false });
      } else if (savedTab === "subadmin_menu_group") {
        await this.getSubUserMenuGroups();
        this.setState({ tableLoader: false });
      } else {
        const listSubUserResponse = await ListSubUserRoles(
          auth.getAccount(),
          auth.getToken(),
        );

        // console.log("ListSubUserRoles Res: ", listSubUserResponse.data);

        const { status, message, errors, data } = listSubUserResponse.data;

        if (
          status === 403 ||
          errors === "authentication missing" ||
          errors === "jwt expired"
        ) {
          auth.logout();
        } else if (status === 404) {
          // Optional: redirect to error page
          this.setState({ tableLoader: false });
        } else if (status === 200 && message === "success") {
          this.setState({
            listRoleData: data,
            tableLoader: false,
          });
        } else {
          this.setState({ tableLoader: false });
        }
      }
    } catch (error) {
      console.error("Error loading sub user roles:", error);
      this.setState({ tableLoader: false });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userRoleItems !== this.props.userRoleItems) {
      const canEdit = UserPermissionHelper.getAllRoles(
        this.props.userRoleItems,
        "settings",
        "default_menu_roles",
      );
      // console.log("Can Edit Clients:", canEdit);

      if (canEdit && Array.isArray(canEdit) && canEdit.length > 0) {
        this.setState({
          permissionsState: canEdit,
          permission_add_group: canEdit[0].add_group,
          permission_edit_group: canEdit[0].edit_group,
          permission_delete_group: canEdit[0].delete_group,
          permission_make_default: canEdit[0].make_default,
          permission_edit_main_menu: canEdit[0].edit_main_menu,
          permission_edit_sub_menu: canEdit[0].edit_sub_menu,
          permission_save_permissions: canEdit[0].save_permissions,
        });
      }
      //console.log("Can Edit Clients:", canEdit);
    }
  }

  handleEditClick = (rowIndex, currentValue) => {
    this.setState({
      isEditing: rowIndex,
      menuSequences: {
        ...this.state.menuSequences,
        [rowIndex]: currentValue,
      },
    });
  };

  handleEditClickSub = (rowIndex, currentValue) => {
    this.setState({
      isEditingSub: rowIndex,
      menuSequencesSub: {
        ...this.state.menuSequencesSub,
        [rowIndex]: currentValue,
      },
    });
  };

  handleCancelEdit = () => {
    this.setState({
      isEditing: null,
      errorMessage: "",
      successMessage: "",
    });
  };

  handleCancelEditSub = () => {
    this.setState({
      isEditingSub: null,
      errorMessage: "",
      successMessage: "",
    });
  };

  handleMenuSequenceChange = (event, rowIndex) => {
    const value = event.target.value;
    this.setState((prevState) => ({
      menuSequences: {
        ...prevState.menuSequences,
        [rowIndex]: value,
      },
    }));
  };

  handleMenuSequenceChangeSub = (event, rowIndex) => {
    const value = event.target.value;
    this.setState((prevState) => ({
      menuSequencesSub: {
        ...prevState.menuSequencesSub,
        [rowIndex]: value,
      },
    }));
  };

  handleSaveClick = async (rowIndex, roleId) => {
    const sequenceNo = this.state.menuSequences[rowIndex];
    if (sequenceNo === "" || !sequenceNo) {
      this.setState({
        errorMessage: "Enter the sequence number.",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 3000);
      return;
    }

    let isMatchFound = this.state.listRoleData.find((role) => {
      return role[3] == sequenceNo && role[7] != roleId;
    });

    if (isMatchFound) {
      this.setState({
        alertModalMessage: (
          <>
            The menu item <b>{isMatchFound[0]}</b> has already used this
            sequence number. Do you want to proceed?
          </>
        ),
        alertModalTitle: "Warning",
        alertModalIcon: "icon ni ni-alert-circle icon-circle-xxl",
        sequenceNo: sequenceNo,
        roleId: roleId,
      });
      window.$("#modalAlertConflict").modal("show");
      return;
    }

    await this.executeSaveSequence(sequenceNo, roleId);
  };

  handleSaveClickSub = async (rowIndex, roleId) => {
    const sequenceNoSub = this.state.menuSequencesSub[rowIndex];

    if (sequenceNoSub === "" || !sequenceNoSub) {
      this.setState({
        errorMessage: "Enter the sequence number.",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 3000);
      return;
    }

    let isMatchFound = this.state.listSubRoleData.find((role) => {
      return (
        role[2] == sequenceNoSub &&
        role[3] == this.state.listSubRoleData[rowIndex][3] &&
        role[7] != roleId
      );
    });

    if (isMatchFound) {
      this.setState({
        alertModalMessageSub: (
          <>
            The sub menu item <b>{isMatchFound[0]}</b> has already used this
            sequence number. Do you want to proceed?
          </>
        ),
        alertModalTitleSub: "Warning",
        alertModalIconSub: "icon ni ni-alert-circle icon-circle-xxl",
        sequenceNoSub: sequenceNoSub,
        roleIdSub: roleId,
      });
      window.$("#modalAlertConflictSub").modal("show");
      return;
    }

    await this.executeSaveSequenceSub(sequenceNoSub, roleId);
  };

  executeSaveSequence = async (sequenceNo, roleId) => {
    this.setState({ isSaving: true });
    try {
      const listSubUserResponse = await setSequenceNo(
        auth.getAccount(),
        auth.getToken(),
        sequenceNo,
        roleId,
      );

      if (
        listSubUserResponse.data.status === 403 ||
        listSubUserResponse.data.errors === "authentication missing" ||
        listSubUserResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (listSubUserResponse.data.status === 404) {
        this.setState({
          errorMessage: "Menu item not found",
          successMessage: "",
          isSaving: false,
        });
      } else if (
        listSubUserResponse.data.status === 200 &&
        listSubUserResponse.data.message === "success"
      ) {
        this.setState(
          {
            errorMessage: "",
            successMessage: "Menu item sequence updated successfully",
            isEditing: null,
            isSaving: false,
          },
          () => {
            setTimeout(() => {
              this.reloadSubUserRoles();
              this.getLeftMenu();
            }, 500);
          },
        );
      }
    } catch (error) {
      console.error("Error updating sequence:", error);
      this.setState({
        errorMessage: "Failed to update menu sequence",
        successMessage: "",
        isSaving: false,
      });
    }
    setTimeout(() => {
      this.setState({
        errorMessage: "",
        successMessage: "",
      });
    }, 3000);
  };

  executeSaveSequenceSub = async (sequenceNoSub, roleId) => {
    this.setState({ isSaving: true });
    try {
      const listSubUserResponse = await setSequenceNoSub(
        auth.getAccount(),
        auth.getToken(),
        sequenceNoSub,
        roleId,
      );

      if (
        listSubUserResponse.data.status === 403 ||
        listSubUserResponse.data.errors === "authentication missing" ||
        listSubUserResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (listSubUserResponse.data.status === 404) {
        this.setState({
          errorMessage: "Menu item not found",
          successMessage: "",
          isSaving: false,
        });
      } else if (
        listSubUserResponse.data.status === 200 &&
        listSubUserResponse.data.message === "success"
      ) {
        this.setState(
          {
            errorMessage: "",
            successMessage: "Menu item sequence updated successfully",
            isEditing: null,
            isSaving: false,
          },
          () => {
            setTimeout(() => {
              this.reloadClientRolesSub();
              this.getLeftMenu();
            }, 500);
          },
        );
      }
    } catch (error) {
      console.error("Error updating sequence:", error);
      this.setState({
        errorMessage: "Failed to update menu sequence",
        successMessage: "",
        isSaving: false,
      });
    }
    setTimeout(() => {
      this.setState({
        errorMessage: "",
        successMessage: "",
      });
    }, 3000);
  };

  reloadSubUserRoles = async () => {
    this.setState({ tableLoader: true });

    try {
      const listSubUserResponse = await ListSubUserRoles(
        auth.getAccount(),
        auth.getToken(),
      );

      if (
        listSubUserResponse.data.status === 403 ||
        listSubUserResponse.data.errors === "authentication missing" ||
        listSubUserResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (
        listSubUserResponse.data.status === 200 &&
        listSubUserResponse.data.message === "success"
      ) {
        this.setState({
          listRoleData: listSubUserResponse.data.data,
          tableLoader: false,
          isEditing: null,
          menuSequences: {},
        });
      } else if (listSubUserResponse.data.status === 404) {
        this.setState({
          errorMessage: "Failed to load roles",
          tableLoader: false,
        });
      }
    } catch (error) {
      console.error("Error reloading roles:", error);
      this.setState({
        errorMessage: "Failed to reload roles",
        tableLoader: false,
      });
    }
  };

  reloadClientRolesSub = async () => {
    this.setState({ tableLoader: true });

    try {
      const listSubUserResponse = await ListSubUserSubRoles(
        auth.getAccount(),
        auth.getToken(),
      );

      if (
        listSubUserResponse.data.status === 403 ||
        listSubUserResponse.data.errors === "authentication missing" ||
        listSubUserResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (
        listSubUserResponse.data.status === 200 &&
        listSubUserResponse.data.message === "success"
      ) {
        this.setState({
          listSubRoleData: listSubUserResponse.data.data,
          tableLoader: false,
          isEditingSub: null,
          menuSequencesSub: {},
        });
      } else if (listSubUserResponse.data.status === 404) {
        this.setState({
          errorMessage: "Failed to load roles",
          tableLoader: false,
        });
      }
    } catch (error) {
      console.error("Error reloading roles:", error);
      this.setState({
        errorMessage: "Failed to reload roles",
        tableLoader: false,
      });
    }
  };

  updateSequence = async () => {
    this.setState({ isSaving: true });
    try {
      const listSubUserResponse = await setSequenceNo(
        auth.getAccount(),
        auth.getToken(),
        this.state.sequenceNo,
        this.state.roleId,
      );

      if (
        listSubUserResponse.data.status === 403 ||
        listSubUserResponse.data.errors === "authentication missing" ||
        listSubUserResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (listSubUserResponse.data.status === 404) {
        this.setState({
          errorMessageMatch: "Menu item not found",
          successMessageMatch: "",
          isSaving: false,
        });
      } else if (
        listSubUserResponse.data.status === 200 &&
        listSubUserResponse.data.message === "success"
      ) {
        this.setState(
          {
            errorMessageMatch: "",
            alertModalTitle: "Success",
            alertModalIcon: "icon ni ni-check-circle icon-circle-xxl",
            successMessageMatch: "Menu item sequence updated successfully",
            isEditing: null,
            isSaving: false,
          },
          () => {
            setTimeout(() => {
              this.reloadSubUserRoles();
              window.$("#modalAlertConflict").modal("hide");
              this.getLeftMenu();
            }, 3000);
          },
        );
      }
    } catch (error) {
      console.error("Error updating sequence:", error);
      this.setState({
        errorMessageMatch: "Failed to update menu sequence",
        successMessageMatch: "",
        isSaving: false,
      });
    }
    this.removeMessages();
  };

  updateSequenceSub = async () => {
    this.setState({ isSaving: true });
    try {
      const listSubUserResponse = await setSequenceNoSub(
        auth.getAccount(),
        auth.getToken(),
        this.state.sequenceNoSub,
        this.state.roleIdSub,
      );

      if (
        listSubUserResponse.data.status === 403 ||
        listSubUserResponse.data.errors === "authentication missing" ||
        listSubUserResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (listSubUserResponse.data.status === 404) {
        this.setState({
          errorMessageMatchSub: "Menu item not found",
          successMessageMatchSub: "",
          isSaving: false,
        });
      } else if (
        listSubUserResponse.data.status === 200 &&
        listSubUserResponse.data.message === "success"
      ) {
        this.setState(
          {
            errorMessageMatchSub: "",
            alertModalTitleSub: "Success",
            alertModalIconSub: "icon ni ni-check-circle icon-circle-xxl",
            successMessageMatch: "Menu item sequence updated successfully",
            isEditingSub: null,
            isSaving: false,
          },
          () => {
            setTimeout(() => {
              this.reloadClientRolesSub();
              window.$("#modalAlertConflictSub").modal("hide");
              this.getLeftMenu();
            }, 3000);
          },
        );
      }
    } catch (error) {
      console.error("Error updating sequence:", error);
      this.setState({
        errorMessageMatchSub: "Failed to update menu sequence",
        successMessageMatchSub: "",
        isSaving: false,
      });
    }
    this.removeMessages();
  };

  removeMessages = () => {
    setTimeout(() => {
      this.setState({
        errorMessageMatch: "",
        successMessageMatch: "",
        errorMessageMatchSub: "",
        successMessageMatchSub: "",
      });
    }, 3000);
  };

  modalHideMatchConflict = () => {
    window.$("#modalAlertConflict").modal("hide");
  };

  modalHideMatchConflictSub = () => {
    window.$("#modalAlertConflictSub").modal("hide");
  };

  getLeftMenu = async () => {
    let user_type = auth.getUserType();
    let acctno = auth.getAccount();

    if (user_type === "Sub") {
      acctno = auth.getSubUserAccount();
    }
    let res = await resellerLeftMenu(acctno, auth.getToken(), auth.getEmail());
    //console.log("getLeftMenu: ", res.data);
    if (
      res.data.status === 200 &&
      res.data.message === "success" &&
      res.data.data.length > 0
    ) {
      this.props.setLeftMenu(res.data.data);
      this.setState({
        leftMenuArr: res.data.data,
        loginDetails: res.data.loginDetails,
      });
    }
  };

  roleStatus = (value, tableMeta) => {
    let active = tableMeta.rowData[4];
    if (active === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Active
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-primary">
          <em className="icon ni ni-na"></em> In Active
        </span>
      );
    }
  };

  roleStatusForSub = (value, tableMeta) => {
    let active = tableMeta.rowData[6];
    if (active === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-danger">
          <em className="icon ni ni-na"></em> No
        </span>
      );
    }
  };

  roleDefault = (value, tableMeta) => {
    let active = tableMeta.rowData[5];
    if (active === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-primary">
          <em className="icon ni ni-na"></em> No
        </span>
      );
    }
  };

  subRoleStatusForSub = (value, tableMeta) => {
    let active = tableMeta.rowData[6];
    if (active === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-danger">
          <em className="icon ni ni-na"></em> No
        </span>
      );
    }
  };

  subRoleStatus = (value, tableMeta) => {
    let active = tableMeta.rowData[4];
    if (active === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Active
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-primary">
          <em className="icon ni ni-na"></em> In Active
        </span>
      );
    }
  };

  subRoleDefault = (value, tableMeta) => {
    let active = tableMeta.rowData[5];
    if (active === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-primary">
          <em className="icon ni ni-na"></em> No
        </span>
      );
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  getSubUserSubRoles = async () => {
    this.setState({
      tableLoader: true,
    });
    const listAgentSubRoleResponce = await ListSubUserSubRoles(
      auth.getAccount(),
      auth.getToken(),
    );

    // console.log("sub user sub roles  Res: ", listAgentSubRoleResponce.data);
    if (
      listAgentSubRoleResponce.data.status === 403 ||
      listAgentSubRoleResponce.data.errors === "authentication missing" ||
      listAgentSubRoleResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listAgentSubRoleResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listAgentSubRoleResponce.data.status === 200 &&
      listAgentSubRoleResponce.data.message === "success"
    ) {
      this.setState({
        listSubRoleData: listAgentSubRoleResponce.data.data,
        tableLoader: false,
        subRoleColumns: [
          { name: "Title" },
          { name: "Link" },
          {
            name: "Menu Sequence",
            options: {
              customBodyRender: (value, tableMeta) => {
                return (
                  <div>
                    {this.state.isEditingSub === tableMeta.rowIndex ? (
                      <div className="flex items-center">
                        <input
                          type="text"
                          value={
                            this.state.menuSequencesSub[tableMeta.rowIndex] ??
                            value
                          }
                          onChange={(e) =>
                            this.handleMenuSequenceChangeSub(
                              e,
                              tableMeta.rowIndex,
                            )
                          }
                          onInput={(e) => {
                            let value = e.target.value.replace(/[^0-9]/g, "");
                            if (value.length === 1) {
                              value = value.replace(/[0]/g, "");
                            }
                            if (
                              value !== "" &&
                              parseInt(value) > 0 &&
                              parseInt(value) <= 99
                            ) {
                              e.target.value = value;
                            } else if (value === "") {
                              e.target.value = "";
                            } else {
                              e.target.value = e.target.previousValue || "";
                            }
                            e.target.previousValue = e.target.value;
                          }}
                          className="w-8 mr-2 p-1 text-center"
                          maxLength="2"
                          disabled={this.state.isSaving}
                          style={{
                            width: "65%",
                          }}
                        />
                        <Tooltip title="Save" placement="top">
                          <span
                            className="mr-2"
                            onClick={() =>
                              this.handleSaveClickSub(
                                tableMeta.rowIndex,
                                tableMeta.rowData[7],
                              )
                            }
                            style={{
                              cursor: this.state.isSaving
                                ? "default"
                                : "pointer",
                              fontSize: "17px",
                              opacity: this.state.isSaving ? "0.5" : "1",
                              pointerEvents: this.state.isSaving
                                ? "none"
                                : "auto",
                            }}
                          >
                            <em className="icon ni ni-save"></em>
                          </span>
                        </Tooltip>

                        {!this.state.isSaving && (
                          <Tooltip title="Close" placement="top">
                            <span
                              onClick={() => this.handleCancelEditSub()}
                              style={{ cursor: "pointer", fontSize: "17px" }}
                            >
                              <em className="icon ni ni-cross"></em>
                            </span>
                          </Tooltip>
                        )}
                      </div>
                    ) : (
                      <div>
                        {value}{" "}
                        <Tooltip title="Edit" placement="top">
                          <span
                            className="mr-1"
                            onClick={() =>
                              this.handleEditClickSub(tableMeta.rowIndex, value)
                            }
                            style={{
                              cursor: "pointer",
                              fontSize: "13px",
                            }}
                          >
                            <em className="icon ni ni-edit"></em>
                          </span>
                        </Tooltip>
                      </div>
                    )}
                  </div>
                );
              },
            },
          },
          { name: "Parent Menu " },
          {
            name: "Status",
            options: {
              customBodyRender: (value, tableMeta) => {
                return <div>{this.subRoleStatus(value, tableMeta)}</div>;
              },
            },
          },
          {
            name: "Default Tab",
            options: {
              customBodyRender: (value, tableMeta) => {
                return <div>{this.subRoleDefault(value, tableMeta)}</div>;
              },
            },
          },
          {
            name: "For Sub User",
            options: {
              customBodyRender: (value, tableMeta) => {
                return <div>{this.subRoleStatusForSub(value, tableMeta)}</div>;
              },
            },
          },
          { name: "ID", options: { display: false } },
          // {
          //   name: "Actions",
          //   options: {
          //     customBodyRender: (value, tableMeta) => {
          //       return (
          //         <div>
          //           <div
          //             className="nk-tb-col nk-tb-col-tools"
          //             style={{ padding: "0px" }}
          //           >
          //             <ul className="nk-tb-actions gx-1">
          //               <li>
          //                 <div className="drodown">
          //                   <a
          //                     href="#"
          //                     className="dropdown-toggle btn btn-icon btn-outline-light"
          //                     data-toggle="dropdown"
          //                   >
          //                     <em className="icon ni ni-more-h"></em>
          //                   </a>
          //                   <div className="dropdown-menu dropdown-menu-right">
          //                     <ul className="link-list-opt no-bdr">
          //                       <li>
          //                         <a
          //                           data-toggle="tooltip"
          //                           data-placement="left"
          //                           onClick={() =>
          //                             this.addMenuHistory(
          //                               "/admin_roles/edit_sub_role/" +
          //                                 tableMeta.rowData[7]
          //                             )
          //                           }
          //                           title="Edit Sub Menu"
          //                           style={{ cursor: "pointer" }}
          //                         >
          //                           <em className="icon ni ni-edit"></em>
          //                           <span>Edit Sub Menu</span>
          //                         </a>
          //                       </li>
          //                     </ul>
          //                   </div>
          //                 </div>
          //               </li>
          //             </ul>
          //           </div>
          //         </div>
          //       );
          //     },
          //   },
          // },
          {
            name: "Actions",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta) => {
                const isDisabled =
                  this.props.is_msa_signed === "No" ||
                  this.props.defaultSettings === "missing";

                const disabledMsg =
                  "Action disabled because MSA is not signed or default settings are missing.";

                return (
                  <>
                    {this.state.permissionsState &&
                    this.state.permissionsState.length > 0 &&
                    this.state.permission_edit_sub_menu === 1 ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          minHeight: 36,
                        }}
                      >
                        {/* Edit Sub Menu */}
                        <Tooltip
                          title={isDisabled ? disabledMsg : "Edit Sub Menu"}
                          placement="top"
                        >
                          <span
                            role="button"
                            tabIndex={0}
                            aria-disabled={isDisabled}
                            onClick={() => {
                              if (!isDisabled) {
                                this.addMenuHistory(
                                  "/admin_roles/edit_sub_role/" +
                                    tableMeta.rowData[7],
                                );
                              }
                            }}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              cursor: isDisabled ? "not-allowed" : "pointer",
                              opacity: isDisabled ? 0.3 : 1,
                            }}
                          >
                            <em
                              className="icon ni ni-edit text-primary"
                              style={{ fontSize: 18 }}
                            />
                          </span>
                        </Tooltip>
                      </div>
                    ) : (
                      "---"
                    )}
                  </>
                );
              },
            },
          },
        ],
      });
    } else {
      //window.location.replace("/error");
    }
  };

  getSubUserPermissions = async () => {
    this.setState({
      tableLoader: true,
    });
    const listAgentSubRoleResponce = await listSubUserPermissions(
      auth.getAccount(),
      auth.getToken(),
    );

    // console.log("getSubUserPermissions: ", listAgentSubRoleResponce.data);
    if (
      listAgentSubRoleResponce.data.status === 403 ||
      listAgentSubRoleResponce.data.errors === "authentication missing" ||
      listAgentSubRoleResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listAgentSubRoleResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listAgentSubRoleResponce.data.status === 200 &&
      listAgentSubRoleResponce.data.message === "success"
    ) {
      this.setState({
        listPermissionRoles: listAgentSubRoleResponce.data.roles,
        listPermissionSubRoles: listAgentSubRoleResponce.data.sub_roles,
        listPermissionData: listAgentSubRoleResponce.data.all_roles,
        tableLoader: false,
      });
    } else {
      //window.location.replace("/error");
    }
  };

  getAllRolesBySubRole = (subRoleName) => {
    const { listPermissionData } = this.state;
    const item = listPermissionData.find(
      (obj) => obj.sub_role_name === subRoleName,
    );

    if (!item) return [];

    try {
      const parsed = JSON.parse(item.all_roles);

      // ensure we always return an array
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.error("Invalid JSON in all_roles:", item.all_roles, e);
      return [];
    }
  };

  getAllRolesByMainRole = (subRoleName) => {
    const { listPermissionData } = this.state;
    const item = listPermissionData.find(
      (obj) => obj.role_name === subRoleName,
    );

    if (!item) return [];

    try {
      const parsed = JSON.parse(item.all_roles);

      // ensure we always return an array
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.error("Invalid JSON in all_roles:", item.all_roles, e);
      return [];
    }
  };

  handleRoleChange = (subRoleName, roleValue, checked, role_title) => {
    this.setState((prevState) => {
      // Clone the listPermissionData
      const updatedList = prevState.listPermissionData.map((item) => {
        if (item.sub_role_name === subRoleName) {
          let rolesArray = [];

          try {
            rolesArray = JSON.parse(item.all_roles);
          } catch (e) {
            console.error("Invalid JSON in all_roles:", item.all_roles);
          }

          // Update the enabled value for the matching role
          const updatedRoles = rolesArray.map((role) =>
            role.value === roleValue
              ? { ...role, enabled: checked ? 1 : 0 }
              : role,
          );

          // Return updated object with new all_roles as JSON string
          return { ...item, all_roles: JSON.stringify(updatedRoles) };
        }
        return item;
      });

      return { listPermissionData: updatedList };
    });
  };

  add_user_permissions = async () => {
    const { listPermissionData } = this.state;
    this.setState({
      roles_button: true,
      permissionErrorMsg: "",
      permissionSuccessMsg: "",
    });
    // console.log("listPermissionData: ", listPermissionData);
    const listAgentSubRoleResponce = await updateUserPermissions(
      auth.getAccount(),
      auth.getToken(),
      JSON.stringify(listPermissionData),
    );

    // console.log("add_user_permissions: ", listAgentSubRoleResponce.data);
    if (
      listAgentSubRoleResponce.data.status === 403 ||
      listAgentSubRoleResponce.data.errors === "authentication missing" ||
      listAgentSubRoleResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listAgentSubRoleResponce.data.status === 404) {
      this.setState({
        roles_button: false,
        permissionErrorMsg:
          "There is some error while updating the permissions.",
        permissionSuccessMsg: "",
      });
      //window.location.replace("/error");
    } else if (
      listAgentSubRoleResponce.data.status === 200 &&
      listAgentSubRoleResponce.data.message === "success"
    ) {
      this.setState({
        roles_button: false,
        permissionErrorMsg: "",
        permissionSuccessMsg: "Permissions updated successfully.",
      });
      setTimeout(() => {
        this.getSubUserPermissions();
      }, 3000);
    } else {
      this.setState({
        roles_button: false,
        permissionErrorMsg:
          "There is some error while updating the permissions.",
        permissionSuccessMsg: "",
      });
      //window.location.replace("/error");
    }
    setTimeout(() => {
      this.setState({
        roles_button: false,
        permissionErrorMsg: "",
        permissionSuccessMsg: "",
      });
    }, 4000);
  };

  getSubUserMenuGroups = async () => {
    this.setState({
      tableLoader: true,
    });
    const listClientMenuGroups = await getSubUserMenuGroups(
      auth.getAccount(),
      auth.getToken(),
    );

    // console.log("Client Menu Groups: ", listClientMenuGroups.data);
    if (
      listClientMenuGroups.data.status === 403 ||
      listClientMenuGroups.data.errors === "authentication missing" ||
      listClientMenuGroups.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listClientMenuGroups.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listClientMenuGroups.data.status === 200 &&
      listClientMenuGroups.data.message === "success"
    ) {
      this.setState({
        listMenuGroupData: listClientMenuGroups.data.data,
        tableLoader: false,
        menuGroupColumns: [
          { name: "Seq#" },
          { name: "Title" },
          {
            name: "Description",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div onClick={() => this.assignedTo(value, tableMeta)}>
                    <span
                      className="badge badge-outline-secondary"
                      style={{ cursor: "pointer" }}
                    >
                      View
                    </span>
                  </div>
                );
              },
            },
          },
          {
            name: "Status",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.activeStatus(value, tableMeta)}</div>;
              },
            },
          },
          { name: "id", options: { display: "false" } },
          {
            name: "Attached Roles",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.attached_roles(value, tableMeta)}</div>;
              },
            },
          },
          {
            name: "Default",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.defaultStatus(value, tableMeta)}</div>;
              },
            },
          },
          // {
          //   name: "Actions",
          //   options: {
          //     customBodyRender: (value, tableMeta, updateValue) => {
          //       return (
          //         <div>
          //           <div
          //             className="nk-tb-col nk-tb-col-tools"
          //             style={{ padding: "0px" }}
          //           >
          //             <ul className="nk-tb-actions gx-1">
          //               <li>
          //                 <div className="drodown">
          //                   <a
          //                     style={{ cursor: "pointer" }}
          //                     title="Other Actions"
          //                     className="dropdown-toggle btn btn-icon  btn-outline-light"
          //                     data-toggle="dropdown"
          //                   >
          //                     <em className="icon ni ni-more-h"></em>
          //                   </a>
          //                   <div className="dropdown-menu dropdown-menu-right">
          //                     <ul className="link-list-opt no-bdr">
          //                       <li>
          //                         <Tooltip title="Edit Group" placement="top">
          //                           <a
          //                             style={{ cursor: "pointer" }}
          //                             onClick={() =>
          //                               this.addMenuHistory(
          //                                 "/client_roles/editGroup/" +
          //                                   tableMeta.rowData[4]
          //                               )
          //                             }
          //                             disabled={
          //                               this.props.is_msa_signed === "No" ||
          //                               this.props.defaultSettings === "missing"
          //                                 ? true
          //                                 : false
          //                             }
          //                           >
          //                             <em className="icon ni ni-edit"></em>
          //                             <span> Edit </span>
          //                           </a>
          //                         </Tooltip>
          //                       </li>
          //                       <li>
          //                         <Tooltip title="Delete Group" placement="top">
          //                           <a
          //                             style={{ cursor: "pointer" }}
          //                             onClick={() =>
          //                               this.handleDeleteGroup(value, tableMeta)
          //                             }
          //                             disabled={
          //                               this.props.is_msa_signed === "No" ||
          //                               this.props.defaultSettings === "missing"
          //                                 ? true
          //                                 : false
          //                             }
          //                           >
          //                             <em className="icon ni ni-trash"></em>
          //                             <span> Delete </span>
          //                           </a>
          //                         </Tooltip>
          //                       </li>
          //                     </ul>
          //                   </div>
          //                 </div>
          //               </li>
          //             </ul>
          //           </div>
          //         </div>
          //       );
          //     },
          //   },
          // },
          {
            name: "Actions",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta) => {
                const isDisabledGlobally =
                  this.props.is_msa_signed === "No" ||
                  this.props.defaultSettings === "missing";

                const id = tableMeta.rowData[5]; // service type id
                const isDefault = tableMeta.rowData[4] === "Yes";

                return (
                  <>
                    {this.state.permissionsState &&
                    this.state.permissionsState.length > 0 &&
                    (this.state.permission_edit_group === 1 ||
                      this.state.permission_make_default === 1 ||
                      this.state.permission_delete_group === 1) ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          minHeight: 36, // ensures consistent row height
                        }}
                      >
                        {/* Edit Group */}
                        {this.state.permissionsState &&
                        this.state.permissionsState.length > 0 &&
                        this.state.permission_edit_group === 1 ? (
                          <Tooltip title="Edit Group" placement="top">
                            <a
                              onClick={() =>
                                this.addMenuHistory(
                                  "/admin_roles/editGroup/" +
                                    tableMeta.rowData[5],
                                )
                              }
                              style={{
                                cursor: isDisabledGlobally
                                  ? "not-allowed"
                                  : "pointer",
                                pointerEvents: isDisabledGlobally
                                  ? "none"
                                  : "auto",
                              }}
                              disabled={isDisabledGlobally}
                            >
                              <em
                                className="icon ni ni-edit text-primary"
                                style={{
                                  fontSize: "20px",
                                  opacity: isDisabledGlobally ? 0.3 : 1,
                                }}
                              />
                            </a>
                          </Tooltip>
                        ) : null}

                        {/* Default Group */}
                        {this.state.permissionsState &&
                        this.state.permissionsState.length > 0 &&
                        this.state.permission_make_default === 1 ? (
                          <Tooltip
                            title={
                              isDefault ? "Unset Default" : "Set as Default"
                            }
                            placement="top"
                          >
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                              onClick={() => {
                                isDefault
                                  ? this.defaultAlertNew(id)
                                  : this.defaultAlert(id);
                              }}
                            >
                              <em
                                className={`icon ni ${
                                  isDefault ? "ni-star-fill" : "ni-star"
                                } text-secondary`}
                                style={{
                                  fontSize: 20,
                                  paddingLeft: 5,
                                  borderLeft:
                                    this.state.permission_edit_group === 1
                                      ? "1px solid rgb(0 0 0 / 87%)"
                                      : "none",
                                }}
                              />
                            </span>
                          </Tooltip>
                        ) : null}

                        {/* Delete Group */}
                        {this.state.permissionsState &&
                        this.state.permissionsState.length > 0 &&
                        this.state.permission_delete_group === 1 ? (
                          <Tooltip title="Delete Group" placement="top">
                            <a
                              onClick={() =>
                                this.handleDeleteGroup(value, tableMeta)
                              }
                              style={{
                                cursor: isDisabledGlobally
                                  ? "not-allowed"
                                  : "pointer",
                                pointerEvents: isDisabledGlobally
                                  ? "none"
                                  : "auto",
                              }}
                              disabled={isDisabledGlobally}
                            >
                              <em
                                className="icon ni ni-trash text-danger"
                                style={{
                                  fontSize: 20,
                                  paddingLeft: 5,
                                  borderLeft:
                                    this.state.permission_edit_group === 1 ||
                                    this.state.permission_make_default === 1
                                      ? "1px solid rgb(0 0 0 / 87%)"
                                      : "none",
                                  opacity: isDisabledGlobally ? 0.3 : 1,
                                }}
                              />
                            </a>
                          </Tooltip>
                        ) : null}
                      </div>
                    ) : (
                      "---"
                    )}
                  </>
                );
              },
            },
          },
        ],
      });
    } else {
      //window.location.replace("/error");
    }
  };

  assignedTo = (value, tableMeta) => {
    let group_desc = tableMeta.rowData[2];
    this.setState(
      {
        group_desc: group_desc,
      },
      () => {
        window.$("#modalGroupDescription").modal("show");
      },
    );
  };

  attachTo = (value, tableMeta) => {
    let attach_group = tableMeta.rowData[7];
    this.setState(
      {
        attach_group: attach_group,
      },
      () => {
        window.$("#modalAttachGroups").modal("show");
      },
    );
  };

  attached_roles = (value, tableMeta) => {
    const groupStatus = tableMeta.rowData[3];
    return (
      <span
        className="badge badge-outline-secondary"
        onClick={() => {
          if (groupStatus === "1") {
            this.getAttachedMenuItem(value, tableMeta);
          } else {
            this.setState({ groupTitle: tableMeta.rowData[1] }, () => {
              window.$("#modalGroupInactiveWarning").modal("show");
            });
          }
        }}
        style={{ cursor: "pointer" }}
      >
        Attached Roles
      </span>
    );
  };

  getAttachedMenuItem = async (value, tableMeta) => {
    let group_id = tableMeta.rowData[5];
    let groupTitle = tableMeta.rowData[1];
    this.setState({
      selected_group_id: group_id,
      groupTitle: groupTitle,
    });
    const listClientMenuGroups = await getAttachedMenuItem(
      auth.getAccount(),
      auth.getToken(),
      group_id,
    );
    // console.log("Attach items: ", listClientMenuGroups.data);
    if (
      listClientMenuGroups.data.status === 403 ||
      listClientMenuGroups.data.errors === "authentication missing" ||
      listClientMenuGroups.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listClientMenuGroups.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listClientMenuGroups.data.status === 200 &&
      listClientMenuGroups.data.message === "success"
    ) {
      this.setState({
        listAttachMenuData: listClientMenuGroups.data.data, // all roles with attached = true/false
        selectedMenus: listClientMenuGroups.data.data
          .filter((item) => item.attached)
          .map((item) => item.id),
      });
    } else {
      //window.location.replace("/error");
    }
    window.$("#modalClientMenuAttach").modal("show");
  };

  toggleMenu = (id) => {
    this.setState((prevState) => {
      const selected = prevState.selectedMenus || [];
      return {
        selectedMenus: selected.includes(id)
          ? selected.filter((item) => item !== id)
          : [...selected, id],
      };
    });
  };

  toggleSelectAll = () => {
    const { listAttachMenuData, selectedMenus } = this.state;
    const allIds = listAttachMenuData.map((item) => item.id);

    const isAllSelected = selectedMenus?.length === allIds.length;

    this.setState({
      selectedMenus: isAllSelected ? [] : allIds,
    });
  };

  saveAttachedMenus = async () => {
    const response = await assignRolesToGroup(
      auth.getAccount(),
      auth.getToken(),
      this.state.selected_group_id,
      this.state.selectedMenus,
    );

    // console.log("Assign response: ", response.data);

    if (
      response.data.status === 403 ||
      response.data.errors === "authentication missing" ||
      response.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (response.data.status === 404) {
      this.setState({
        errorMessageAttach:
          "There is some error while assigning menu to the group.",
        successMessageAttach: "",
        disabled: false,
      });
      setTimeout(() => {
        this.setState({ errorMessageAttach: "" });
      }, 3000);
    } else if (
      response.data.status === 200 &&
      response.data.message === "success"
    ) {
      this.setState({
        errorMessageAttach: "",
        successMessageAttach: "Menu successfully assigned to the group.",
        disabled: false,
      });

      setTimeout(() => {
        this.setState({
          errorMessageAttach: "",
          successMessageAttach: "",
          errorMessageWarning: "",
        });
        window.$("#modalClientMenuAttach").modal("hide");
      }, 3000);
    } else {
      this.setState({
        errorMessageAttach:
          "There is some error while assigning menu to group.",
        successMessageAttach: "",
        disabled: false,
      });
      setTimeout(() => {
        this.setState({ errorMessageAttach: "", successMessageAttach: "" });
      }, 3000);
    }
  };

  handleDeleteGroup = (value, tableMeta) => {
    let selected_group_id = tableMeta.rowData[5];
    this.setState({
      selected_group_id: selected_group_id,
      successMessageAttach: "",
      errorMessageAttach: "",
    });
    window.$("#modalDeleteGroup").modal("show");
  };

  modalHideDelGroup = () => {
    window.$("#modalDeleteGroup").modal("hide");
  };

  deleteMenuGroup = async () => {
    this.setState({
      disabled: true,
      errorMessageAttach: "",
      successMessageAttach: "",
    });
    const servicesResponse = await deleteMenuGroup(
      auth.getAccount(),
      auth.getToken(),
      this.state.selected_group_id,
    );

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "not_found"
    ) {
      this.setState({
        errorMessageAttach: "Error group not found.",
        successMessageAttach: "",
        disabled: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState(
        {
          successMessageAttach: "Group deleted successfully.",
          errorMessageAttach: "",
          disabled: false,
        },
        () => {
          setTimeout(() => {
            window.$("#modalDeleteGroup").modal("hide");
            this.getSubUserMenuGroups();
            this.setState({ successMessageAttach: "", errorMessageAttach: "" });
          }, 3000);
        },
      );
    }
  };

  activeStatus = (value, tableMeta) => {
    let status = tableMeta.rowData[3];
    if (status === "1") {
      return <span className="badge badge-outline-success">Active</span>;
    } else {
      return <span className="badge badge-outline-danger">Inactive</span>;
    }
  };

  defaultStatus = (value, tableMeta) => {
    let status = tableMeta.rowData[4];
    if (status === "Yes") {
      return <span className="badge badge-outline-success">Yes</span>;
    } else {
      return <span className="badge badge-outline-danger">No</span>;
    }
  };

  defaultAlert = (value) => {
    let id = value;
    this.setState({
      selected_group_id: id,
    });
    window.$("#modalDefaultAlert").modal("show");
  };

  modalHideDefault = () => {
    window.$("#modalDefaultAlert").modal("hide");
  };

  setDefault = async () => {
    let group_id = this.state.selected_group_id;
    this.setState({ isProcessing: true });
    const serviceResponce = await setDefault(
      auth.getAccount(),
      auth.getToken(),
      group_id,
    );

    // console.log("defaultServiceResponse: ", serviceResponce.data);

    if (
      serviceResponce.data.status === 403 ||
      serviceResponce.data.errors === "authentication missing" ||
      serviceResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      serviceResponce.data.status === 404 &&
      serviceResponce.data.message === "fail" &&
      serviceResponce.data.note !== ""
    ) {
      // window.location.replace("/error");
      this.setState({
        errorMessageDefault: serviceResponce.data.note,
        successMessageDefault: "",
        disabled: false,
        isProcessing: false,
      });
    } else if (
      serviceResponce.data.status === 200 &&
      serviceResponce.data.message === "success"
    ) {
      this.setState(
        {
          errorMessageDefault: "",
          successMessageDefault: "Group set as default successfully.",
          disabled: false,
          isProcessing: false,
        },
        () => {
          setTimeout(() => {
            window.$("#modalDefaultAlert").modal("hide");
            this.getSubUserMenuGroups();
            this.setState({
              successMessageDefault: "",
              errorMessageDefault: "",
              isProcessing: false,
              disabled: false,
            });
          }, 3000);
        },
      );
    } else {
      this.setState({
        errorMessageDefault: serviceResponce.data.message,
        successMessageDefault: "",
        disabled: false,
        isProcessing: false,
      });
      //window.location.replace("/error");
    }
  };

  defaultAlertNew = (value) => {
    let id = value;
    this.setState({
      selected_group_id: id,
    });
    window.$("#modalDefaultAlertNew").modal("show");
  };

  modalHideDefaultNew = () => {
    window.$("#modalDefaultAlertNew").modal("hide");
  };

  unsetDefault = async () => {
    let group_id = this.state.selected_group_id;
    this.setState({ isProcessing: true });
    const serviceResponce = await unsetDefault(
      auth.getAccount(),
      auth.getToken(),
      group_id,
    );

    // console.log("defaultServiceResponse: ", serviceResponce.data);

    if (
      serviceResponce.data.status === 403 ||
      serviceResponce.data.errors === "authentication missing" ||
      serviceResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      serviceResponce.data.status === 404 &&
      serviceResponce.data.message === "fail" &&
      serviceResponce.data.note !== ""
    ) {
      // window.location.replace("/error");
      this.setState({
        errorMessageDefault: serviceResponce.data.note,
        successMessageDefault: "",
        disabled: false,
        isProcessing: false,
      });
    } else if (
      serviceResponce.data.status === 200 &&
      serviceResponce.data.message === "success"
    ) {
      this.setState(
        {
          errorMessageDefault: "",
          successMessageDefault: "Default status removed successfully.",
          disabled: false,
          isProcessing: false,
        },
        () => {
          setTimeout(() => {
            window.$("#modalDefaultAlertNew").modal("hide");
            this.getSubUserMenuGroups();
            this.setState({
              successMessageDefault: "",
              errorMessageDefault: "",
              isProcessing: false,
              disabled: false,
            });
          }, 3000);
        },
      );
    } else {
      this.setState({
        errorMessageDefault: serviceResponce.data.message,
        successMessageDefault: "",
        disabled: false,
        isProcessing: false,
      });
      //window.location.replace("/error");
    }
  };

  handleSearchChange = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    this.setState({ listPermissionRoles: searchTerm });
  };

  render() {
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}
          {/* MODAL EDIT PROFILE START */}
          {/* MSA WARNING END */}
          <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
              <div className="nk-block-head-content">
                <h3 className="nk-block-title page-title">
                  <PageTitle
                    name="Admin Default Menu/Roles"
                    icon="icon ni ni-grid-alt"
                  />
                </h3>
              </div>
              <div className="nk-block-head-content" id="HeadContent">
                <div className="toggle-wrap nk-block-tools-toggle">
                  <a
                    href="#"
                    className="btn btn-icon btn-trigger toggle-expand mr-n1"
                    data-target="pageMenu"
                  >
                    {/*<em className="icon ni ni-more-v"></em>*/}
                  </a>
                  <div
                    className="toggle-expand-content"
                    data-content="pageMenu"
                  >
                    <ul className="nk-block-tools g-3">
                      <li className="nk-block-tools-opt">
                        {this.state.permissionsState &&
                        this.state.permissionsState.length > 0 &&
                        this.state.permission_add_group === 1 ? (
                          <button
                            type="button"
                            style={{ cursor: "pointer", color: "#fff" }}
                            onClick={() =>
                              this.addMenuHistory("/admin_roles/addGroup")
                            }
                            className="btn btn-primary"
                          >
                            <em className="icon ni ni-plus-round"></em>
                            &nbsp;Add New Group
                          </button>
                        ) : null}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="nk-block">
            {/* Table 5th Col Start */}
            <div className="row g-gs">
              <div className="col-xxl-12">
                {this.state.errorMessage !== "" ? (
                  <div className="example-alert mb-2">
                    <div className="alert alert-pro alert-danger">
                      <div className="alert-text">
                        <h4>Error</h4>
                        <p>{this.state.errorMessage}</p>
                      </div>
                    </div>
                  </div>
                ) : null}
                {this.state.successMessage !== "" ? (
                  <div className="example-alert mb-2">
                    <div className="alert alert-pro alert-success">
                      <div className="alert-text">
                        <h4>Success</h4>
                        <p>{this.state.successMessage}</p>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="nk-block nk-block-lg">
                  <div className="row g-gs">
                    <div className="col-xxl-12">
                      <div className="nk-block nk-block-lg">
                        <div className="card card-bordered">
                          <div className="card-inner">
                            <ul className="nav nav-tabs">
                              <li className="nav-item">
                                <a
                                  className={`nav-link ${
                                    this.state.subUserMenuTab === "main_menu"
                                      ? "active"
                                      : ""
                                  }`}
                                  data-toggle="tab"
                                  href="#adminEmails"
                                  onClick={() => {
                                    this.setState({
                                      subUserMenuTab: "main_menu",
                                    });
                                    localStorage.setItem(
                                      "subUserMenuTab",
                                      "main_menu",
                                    );
                                    this.componentDidMount(); // or call specific refresh logic
                                  }}
                                >
                                  <em className="icon ni ni-grid-alt"></em>
                                  <span>Main Menu</span>
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className={`nav-link ${
                                    this.state.subUserMenuTab === "sub_menu"
                                      ? "active"
                                      : ""
                                  }`}
                                  data-toggle="tab"
                                  href="#agentEmails"
                                  onClick={() => {
                                    this.setState({
                                      subUserMenuTab: "sub_menu",
                                    });
                                    localStorage.setItem(
                                      "subUserMenuTab",
                                      "sub_menu",
                                    );
                                    this.getSubUserSubRoles();
                                  }}
                                >
                                  <em className="icon ni ni-grid-alt"></em>
                                  <span>Sub Menu</span>
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className={`nav-link ${
                                    this.state.subUserMenuTab ===
                                    "subadmin_menu_group"
                                      ? "active"
                                      : ""
                                  }`}
                                  data-toggle="tab"
                                  href="#agentEmails"
                                  onClick={() => {
                                    this.setState({
                                      subUserMenuTab: "subadmin_menu_group",
                                    });
                                    localStorage.setItem(
                                      "subUserMenuTab",
                                      "subadmin_menu_group",
                                    );
                                    this.getSubUserMenuGroups();
                                  }}
                                >
                                  <em className="icon ni ni-link-group"></em>
                                  <span>Menu Groups</span>
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className={`nav-link ${
                                    this.state.subUserMenuTab ===
                                    "subadmin_roles"
                                      ? "active"
                                      : ""
                                  }`}
                                  data-toggle="tab"
                                  href="#agentEmails"
                                  onClick={() => {
                                    this.setState({
                                      subUserMenuTab: "subadmin_roles",
                                    });
                                    localStorage.setItem(
                                      "subUserMenuTab",
                                      "subadmin_roles",
                                    );
                                    this.getSubUserPermissions();
                                  }}
                                >
                                  <em className="icon ni ni-grid-alt"></em>
                                  <span>Sub User Permissions</span>
                                </a>
                              </li>
                            </ul>
                            <div className="tab-content">
                              <div
                                className={`tab-pane ${
                                  this.state.subUserMenuTab === "main_menu"
                                    ? "active"
                                    : ""
                                }`}
                                id="adminEmails"
                              >
                                {this.state.tableLoader === true ? (
                                  tableLoader()
                                ) : (
                                  <DataTable
                                    columns={this.state.rolecolumns}
                                    tableData={this.state.listRoleData}
                                    title="Main Menu"
                                  />
                                )}
                              </div>
                              <div
                                className={`tab-pane ${
                                  this.state.subUserMenuTab === "sub_menu"
                                    ? "active"
                                    : ""
                                }`}
                                id="agentEmails"
                              >
                                {this.state.tableLoader === true ? (
                                  tableLoader()
                                ) : (
                                  <DataTable
                                    columns={this.state.subRoleColumns}
                                    tableData={this.state.listSubRoleData}
                                    title="Sub Menu"
                                  />
                                )}
                              </div>
                              <div
                                className={`tab-pane ${
                                  this.state.subUserMenuTab === "subadmin_roles"
                                    ? "active"
                                    : ""
                                }`}
                                id="subadminRoles"
                              >
                                {this.state.tableLoader === true ? (
                                  tableLoader()
                                ) : (
                                  <>
                                    <h5>User Permissions</h5>
                                    <p>
                                      The User Permissions module allows
                                      administrators to control access to
                                      different areas and features of the system
                                      for each sub-user.
                                    </p>
                                    <div className="nk-block" id="rolesDiv">
                                      {this.state.permissionErrorMsg &&
                                      this.state.permissionErrorMsg !== "" ? (
                                        <div
                                          className="example-alert"
                                          style={{ marginBottom: "15px" }}
                                        >
                                          <div className="alert alert-pro alert-danger">
                                            <div className="alert-text">
                                              <h4>Error</h4>
                                              <p>
                                                {this.state.permissionErrorMsg}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                      {this.state.permissionSuccessMsg &&
                                      this.state.permissionSuccessMsg !== "" ? (
                                        <div
                                          className="example-alert"
                                          style={{ marginBottom: "15px" }}
                                        >
                                          <div className="alert alert-pro alert-success">
                                            <div className="alert-text">
                                              <h4>Success</h4>
                                              <p>
                                                {
                                                  this.state
                                                    .permissionSuccessMsg
                                                }
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                      <div className="d-flex justify-content-end mb-2">
                                        {this.state.roles_button === false ? (
                                          <>
                                            {this.state.permissionsState &&
                                            this.state.permissionsState.length >
                                              0 &&
                                            this.state
                                              .permission_save_permissions ===
                                              1 ? (
                                              <button
                                                type="button"
                                                className="btn btn-lg btn-primary"
                                                onClick={() =>
                                                  this.add_user_permissions()
                                                }
                                                disabled={this.state.disabled}
                                              >
                                                <em className="icon ni ni-save"></em>{" "}
                                                &nbsp; Save Permissions
                                              </button>
                                            ) : null}
                                          </>
                                        ) : (
                                          <button
                                            className="btn btn-lg btn-primary"
                                            style={{ marginRight: "15px" }}
                                            disabled
                                          >
                                            <em className="icon ni ni-save"></em>{" "}
                                            &nbsp; Save Permissions
                                            <div
                                              className="spinner-grow spinner-grow-sm"
                                              role="status"
                                            >
                                              <span className="sr-only">
                                                Loading...
                                              </span>
                                            </div>
                                          </button>
                                        )}
                                      </div>
                                      <div className="row g-4">
                                        <div className="col-md-12 mb-4">
                                          <div className="form-group position-relative">
                                            <input
                                              type="text"
                                              className="form-control with-icon"
                                              placeholder="Search User Permission"
                                              value={this.state.searchTerm}
                                              onChange={(e) =>
                                                this.setState({
                                                  searchTerm: e.target.value,
                                                })
                                              }
                                            />
                                            <em className="icon ni ni-search inside-icon"></em>
                                          </div>
                                        </div>
                                      </div>
                                      <table
                                        className="table table-bordered permissions-table"
                                        border="0"
                                      >
                                        <thead>
                                          <tr>
                                            <th>Module / Sub-Module</th>
                                            <th>Actions</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.listPermissionRoles &&
                                          this.state.listPermissionRoles
                                            .length > 0 ? (
                                            <>
                                              {this.state.listPermissionRoles
                                                .filter((roles) => {
                                                  const term =
                                                    this.state.searchTerm.toLowerCase();

                                                  // Check if role_title matches OR if any sub_role matches
                                                  const hasMatchingSub =
                                                    this.state.listPermissionSubRoles.some(
                                                      (sub) =>
                                                        sub.role_name ===
                                                          roles.role_name &&
                                                        sub.sub_role_title
                                                          .toLowerCase()
                                                          .includes(term),
                                                    );

                                                  return (
                                                    roles.role_title
                                                      .toLowerCase()
                                                      .includes(term) ||
                                                    hasMatchingSub ||
                                                    term === ""
                                                  );
                                                })
                                                .map((roles, idx) => (
                                                  <>
                                                    <tr key={`r-${idx}`}>
                                                      <td
                                                        className="module-title"
                                                        style={{ width: "20%" }}
                                                      >
                                                        {roles.role_title}
                                                      </td>
                                                      <td></td>
                                                    </tr>

                                                    {this.state
                                                      .listPermissionSubRoles &&
                                                    this.state
                                                      .listPermissionSubRoles
                                                      .length > 0 ? (
                                                      <>
                                                        {this.state.listPermissionSubRoles
                                                          .filter(
                                                            (sub) =>
                                                              sub.role_name ===
                                                                roles.role_name &&
                                                              (sub.sub_role_title
                                                                .toLowerCase()
                                                                .includes(
                                                                  this.state.searchTerm.toLowerCase(),
                                                                ) ||
                                                                roles.role_title
                                                                  .toLowerCase()
                                                                  .includes(
                                                                    this.state.searchTerm.toLowerCase(),
                                                                  ) ||
                                                                this.state
                                                                  .searchTerm ===
                                                                  ""),
                                                          )
                                                          .map(
                                                            (
                                                              sub_roles,
                                                              idx2,
                                                            ) => {
                                                              const roleArray =
                                                                this.getAllRolesBySubRole(
                                                                  sub_roles.sub_role_name,
                                                                );

                                                              return (
                                                                <tr
                                                                  key={`rs-${idx2}`}
                                                                >
                                                                  <td>
                                                                    {
                                                                      sub_roles.sub_role_title
                                                                    }
                                                                  </td>
                                                                  <td>
                                                                    <div className="row">
                                                                      {Array.isArray(
                                                                        roleArray,
                                                                      ) &&
                                                                      roleArray.length >
                                                                        0 ? (
                                                                        roleArray.map(
                                                                          (
                                                                            role,
                                                                            i,
                                                                          ) => (
                                                                            <div
                                                                              className="col-md-3"
                                                                              key={
                                                                                role.value ||
                                                                                `${idx2}-${i}`
                                                                              }
                                                                            >
                                                                              <div
                                                                                className="custom-control custom-checkbox"
                                                                                style={{
                                                                                  marginRight:
                                                                                    "25px",
                                                                                  marginBottom:
                                                                                    "7px",
                                                                                  marginTop:
                                                                                    "10px",
                                                                                }}
                                                                              >
                                                                                <input
                                                                                  name="sub_role"
                                                                                  type="checkbox"
                                                                                  className="custom-control-input vdrSelected2"
                                                                                  id={`chk_${sub_roles.sub_role_name}-${idx2}-${i}`}
                                                                                  value={
                                                                                    role.value
                                                                                  }
                                                                                  checked={
                                                                                    role.enabled ===
                                                                                    1
                                                                                  }
                                                                                  onChange={(
                                                                                    e,
                                                                                  ) =>
                                                                                    this.handleRoleChange(
                                                                                      sub_roles.sub_role_name,
                                                                                      role.value,
                                                                                      e
                                                                                        .target
                                                                                        .checked,
                                                                                      role.title,
                                                                                    )
                                                                                  }
                                                                                />
                                                                                <label
                                                                                  className="custom-control-label"
                                                                                  htmlFor={`chk_${sub_roles.sub_role_name}-${idx2}-${i}`}
                                                                                >
                                                                                  {
                                                                                    role.title
                                                                                  }
                                                                                </label>
                                                                              </div>
                                                                            </div>
                                                                          ),
                                                                        )
                                                                      ) : (
                                                                        <span>
                                                                          No
                                                                          roles
                                                                        </span>
                                                                      )}
                                                                    </div>
                                                                  </td>
                                                                </tr>
                                                              );
                                                            },
                                                          )}
                                                      </>
                                                    ) : null}
                                                  </>
                                                ))}
                                            </>
                                          ) : null}
                                        </tbody>
                                      </table>
                                      <div className="d-flex justify-content-end mt-4">
                                        {this.state.roles_button === false ? (
                                          <>
                                            {this.state.permissionsState &&
                                            this.state.permissionsState.length >
                                              0 &&
                                            this.state
                                              .permission_save_permissions ===
                                              1 ? (
                                              <button
                                                type="button"
                                                className="btn btn-lg btn-primary"
                                                onClick={() =>
                                                  this.add_user_permissions()
                                                }
                                                disabled={this.state.disabled}
                                              >
                                                <em className="icon ni ni-save"></em>{" "}
                                                &nbsp; Save Permissions
                                              </button>
                                            ) : null}
                                          </>
                                        ) : (
                                          <button
                                            className="btn btn-lg btn-primary"
                                            style={{ marginRight: "15px" }}
                                            disabled
                                          >
                                            <em className="icon ni ni-swap"></em>{" "}
                                            Save Permissions
                                            <div
                                              className="spinner-grow spinner-grow-sm"
                                              role="status"
                                            >
                                              <span className="sr-only">
                                                Loading...
                                              </span>
                                            </div>
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                              <div
                                className={`tab-pane ${
                                  this.state.subUserMenuTab ===
                                  "subadmin_menu_group"
                                    ? "active"
                                    : ""
                                }`}
                                id="agentEmails"
                              >
                                {this.state.tableLoader === true ? (
                                  tableLoader()
                                ) : (
                                  <DataTable
                                    columns={this.state.menuGroupColumns}
                                    tableData={this.state.listMenuGroupData}
                                    title="Menu Groups"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Table 5th Col End */}
            {/* ROLE MATCH ALERT START */}
            <div className="modal fade" tabIndex="-1" id="modalAlertConflict">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <a
                    style={{ cursor: "pointer" }}
                    className="close"
                    onClick={() => {
                      this.modalHideMatchConflict();
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-body modal-body-lg text-center">
                    <div className="nk-modal">
                      <em
                        className={this.state.alertModalIcon}
                        style={{
                          fontSize: "6rem",
                        }}
                      ></em>

                      <h4 className="nk-modal-title">
                        {this.state.alertModalTitle}
                      </h4>

                      <div className="nk-modal-text">
                        <p>{this.state.alertModalMessage}</p>
                        {this.state.errorMessageMatch !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>Error</h4>
                                <p>{this.state.errorMessageMatch}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessageMatch !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <h4>Success</h4>
                                <p>{this.state.successMessageMatch}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="nk-modal-action">
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.modalHideMatchConflict();
                          }}
                        >
                          CANCEL
                        </a>
                        {"  "}
                        <a
                          style={{
                            cursor: "pointer",
                          }}
                          className="btn btn-lg btn-mw btn-primary"
                          onClick={() => {
                            this.updateSequence();
                          }}
                          disabled={this.state.isSaving}
                        >
                          {this.state.isSaving ? (
                            <span>UPDATING...</span>
                          ) : (
                            <span>UPDATE</span>
                          )}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* ROLE MATCH ALERT END */}
            {/* SUB ROLE MATCH ALERT START */}
            <div
              className="modal fade"
              tabIndex="-1"
              id="modalAlertConflictSub"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <a
                    style={{ cursor: "pointer" }}
                    className="close"
                    onClick={() => {
                      this.modalHideMatchConflictSub();
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-body modal-body-lg text-center">
                    <div className="nk-modal">
                      <em
                        className={this.state.alertModalIconSub}
                        style={{
                          fontSize: "6rem",
                        }}
                      ></em>

                      <h4 className="nk-modal-title">
                        {this.state.alertModalTitleSub}
                      </h4>

                      <div className="nk-modal-text">
                        <p>{this.state.alertModalMessageSub}</p>
                        {this.state.errorMessageMatch !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>Error</h4>
                                <p>{this.state.errorMessageMatch}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessageMatch !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <h4>Success</h4>
                                <p>{this.state.successMessageMatch}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="nk-modal-action">
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.modalHideMatchConflictSub();
                          }}
                        >
                          CANCEL
                        </a>
                        {"  "}
                        <a
                          style={{
                            cursor: "pointer",
                          }}
                          className="btn btn-lg btn-mw btn-primary"
                          onClick={() => {
                            this.updateSequenceSub();
                          }}
                          disabled={this.state.isSaving}
                        >
                          {this.state.isSaving ? (
                            <span>UPDATING...</span>
                          ) : (
                            <span>UPDATE</span>
                          )}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* SUB ROLE MATCH ALERT END */}
            {/* SUB ROLE MATCH ALERT START */}
            <div
              className="modal fade"
              tabIndex="-1"
              id="modalAlertConflictSub"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <a
                    style={{ cursor: "pointer" }}
                    className="close"
                    onClick={() => {
                      this.modalHideMatchConflictSub();
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-body modal-body-lg text-center">
                    <div className="nk-modal">
                      <em
                        className={this.state.alertModalIconSub}
                        style={{
                          fontSize: "6rem",
                        }}
                      ></em>

                      <h4 className="nk-modal-title">
                        {this.state.alertModalTitleSub}
                      </h4>

                      <div className="nk-modal-text">
                        <p>{this.state.alertModalMessageSub}</p>
                        {this.state.errorMessageMatch !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>Error</h4>
                                <p>{this.state.errorMessageMatch}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessageMatch !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <h4>Success</h4>
                                <p>{this.state.successMessageMatch}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="nk-modal-action">
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.modalHideMatchConflictSub();
                          }}
                        >
                          CANCEL
                        </a>
                        {"  "}
                        <a
                          style={{
                            cursor: "pointer",
                          }}
                          className="btn btn-lg btn-mw btn-primary"
                          onClick={() => {
                            this.updateSequenceSub();
                          }}
                          disabled={this.state.isSaving}
                        >
                          {this.state.isSaving ? (
                            <span>UPDATING...</span>
                          ) : (
                            <span>UPDATE</span>
                          )}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* SUB ROLE MATCH ALERT END */}
            {/* Modal Group Desc */}
            <div
              className="modal fade"
              tabIndex="-1"
              id="modalGroupDescription"
            >
              <div
                className="modal-dialog modal-xl modal-dialog-top"
                role="document"
              >
                <div className="modal-content">
                  <a
                    href="#"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-header">
                    <h5 className="modal-title">Group Description</h5>
                  </div>
                  <div className="modal-body">
                    <p className="text-dark">
                      {this.state.group_desc && this.state.group_desc !== ""
                        ? this.state.group_desc
                        : "No Description"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Modal Group Desc */}
            {/* Client Menu Assignment Modal */}
            <div
              className="modal fade"
              tabIndex="-1"
              id="modalClientMenuAttach"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-top"
                role="document"
                style={{ maxWidth: "600px" }}
              >
                <div className="modal-content">
                  <div
                    className="modal-header"
                    style={{ paddingTop: "10px", paddingBottom: "10px" }}
                  >
                    <div
                      className="modal-title"
                      style={{ textAlign: "center", fontSize: "18px" }}
                    >
                      <strong>
                        <em
                          className="icon ni ni-grid-alt"
                          style={{ marginRight: "5px" }}
                        ></em>
                        Attach Roles{" "}
                        <sup>
                          <small className="text-soft">
                            {this.state.groupTitle}
                          </small>
                        </sup>
                      </strong>
                    </div>
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                  </div>

                  <div className="modal-body text-left">
                    <div className="nk-modal">
                      {this.state.errorMessageAttach !== "" && (
                        <div className="example-alert example-alert-revoke">
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageAttach}</p>
                            </div>
                          </div>
                        </div>
                      )}

                      {this.state.successMessageAttach !== "" && (
                        <div className="example-alert example-alert-revoke">
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageAttach}</p>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="nk-modal-text mt-2">
                        {this.state.menuLoading ? (
                          tableLoader()
                        ) : (
                          <div className="card card-bordered card-preview">
                            <table className="table table-sm">
                              <thead className="tb-odr-head">
                                <tr className="tb-odr-item">
                                  <th
                                    width="15%"
                                    style={{
                                      borderRight: "1px solid #dbdfea",
                                      fontWeight: 600,
                                      textTransform: "uppercase",
                                      textAlign: "center",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    <Checkbox
                                      checked={
                                        this.state.listAttachMenuData?.length >
                                          0 &&
                                        this.state.selectedMenus?.length ===
                                          this.state.listAttachMenuData.length
                                      }
                                      indeterminate={false}
                                      onChange={this.toggleSelectAll}
                                      color="primary"
                                      size="small"
                                    />
                                  </th>
                                  <th
                                    width="85%"
                                    style={{
                                      fontWeight: 600,
                                      textTransform: "uppercase",
                                      textAlign: "left",
                                      paddingLeft: "20px",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    Menu Title
                                  </th>
                                </tr>
                              </thead>

                              <tbody className="tb-odr-body">
                                {this.state.listAttachMenuData?.map(
                                  (menuItem, index) => (
                                    <tr key={`menu${index}`}>
                                      <td
                                        style={{
                                          borderRight: "1px solid #dbdfea",
                                          verticalAlign: "middle",
                                          textAlign: "center",
                                        }}
                                      >
                                        <Checkbox
                                          checked={
                                            this.state.selectedMenus?.includes(
                                              menuItem.id,
                                            ) || false
                                          }
                                          onChange={() =>
                                            this.toggleMenu(menuItem.id)
                                          }
                                          color="primary"
                                          size="small"
                                        />
                                      </td>
                                      <td
                                        style={{
                                          verticalAlign: "middle",
                                          paddingLeft: "20px",
                                          fontWeight: 500,
                                        }}
                                      >
                                        {menuItem.title}
                                      </td>
                                    </tr>
                                  ),
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}

                        <div className="nk-modal-action text-right mt-3">
                          <a
                            href="#"
                            className="btn btn-md btn-primary"
                            onClick={this.saveAttachedMenus}
                            disabled={this.state.disableMenuSave}
                          >
                            Save Changes
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* END Client Menu Assignment Modal */}
            {/* START Agent DELETE MODAL  */}
            <div className="modal fade" tabIndex="-1" id="modalDeleteGroup">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <a
                    style={{ cursor: "pointer" }}
                    className="close"
                    onClick={() => {
                      this.modalHideDelGroup();
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-body modal-body-lg text-center">
                    <div className="nk-modal">
                      <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>

                      <h4 className="nk-modal-title">
                        Do you want to delete the group?
                      </h4>

                      <div className="nk-modal-text">
                        {this.state.errorMessageAttach !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>Error</h4>
                                <p>{this.state.errorMessageAttach}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessageAttach !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <h4>Success</h4>
                                <p>{this.state.successMessageAttach}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="nk-modal-action">
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-primary"
                          onClick={() => {
                            this.modalHideDelGroup();
                          }}
                        >
                          CANCEL
                        </a>
                        {"  "}
                        <button
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.deleteMenuGroup();
                          }}
                          disabled={
                            this.state.disabled || this.state.isProcessing
                          } // disable button when processing
                        >
                          {this.state.isProcessing ? (
                            <span>DELETING...</span>
                          ) : (
                            <span>DELETE</span>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* END Client DELETE MODAL  */}
            {/* START Inactive Group Warning MODAL  */}
            <div
              className="modal fade"
              tabIndex="-1"
              id="modalGroupInactiveWarning"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <a
                    style={{ cursor: "pointer" }}
                    className="close"
                    onClick={() => {
                      window.$("#modalGroupInactiveWarning").modal("hide");
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-body modal-body-lg text-center">
                    <div className="nk-modal">
                      <em
                        className="nk-modal-icon ni ni-alert-circle text-warning"
                        style={{ fontSize: "48px" }}
                      ></em>

                      <h4 className="nk-modal-title">Inactive Menu Group</h4>

                      <div className="nk-modal-text mt-2">
                        <p>
                          The group <strong>{this.state.groupTitle}</strong> is
                          currently <strong>inactive</strong>.
                        </p>
                        <p>
                          You must activate the group to view the roles attached
                          to it or to assign new menu roles.
                        </p>
                      </div>

                      <div className="nk-modal-action mt-4">
                        <button
                          type="button"
                          className="btn btn-lg btn-mw btn-primary"
                          onClick={() => {
                            window
                              .$("#modalGroupInactiveWarning")
                              .modal("hide");
                          }}
                        >
                          OKAY
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* END Inactive Group Warning MODAL  */}
            {/* Modal Group Desc */}
            <div className="modal fade" tabIndex="-1" id="modalAttachGroups">
              <div
                className="modal-dialog modal-md modal-dialog-top"
                role="document"
              >
                <div className="modal-content">
                  <a
                    href="#"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-header">
                    <h5 className="modal-title">Attached Groups</h5>
                  </div>
                  <div className="modal-body">
                    {Array.isArray(this.state.attach_group) &&
                    this.state.attach_group.length > 0 ? (
                      <div className="d-flex flex-wrap" style={{ gap: "10px" }}>
                        {this.state.attach_group.map((group, index) => (
                          <div
                            key={index}
                            className="d-flex align-items-center shadow-sm"
                            style={{
                              backgroundColor: "#f1f5f9",
                              padding: "6px 14px",
                              fontSize: "14px",
                              color: "#1e293b",
                              fontWeight: 500,
                            }}
                          >
                            <em
                              className="icon ni ni-dot-fill"
                              style={{
                                color: "#5b93ff",
                                marginRight: "6px",
                                fontSize: "12px",
                              }}
                            ></em>
                            {group.group_title}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-dark">No Groups Attached</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Modal Group Desc */}
            {/* MODAL DEFAULT GROUP START */}
            <div className="modal fade" tabIndex="-1" id="modalDefaultAlert">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <a
                    style={{ cursor: "pointer" }}
                    className="close"
                    onClick={() => {
                      this.modalHideDefault();
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-body modal-body-lg text-center">
                    <div className="nk-modal">
                      <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-star-fill bg-success"></em>
                      <h4 className="nk-modal-title">Make Default Group?</h4>
                      {this.state.errorMessageDefault !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageDefault}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessageDefault !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageDefault}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div className="nk-modal-text">
                        <div className="caption-text">
                          Are you sure you want make this group default?
                        </div>
                      </div>
                      <div className="nk-modal-action">
                        <button
                          style={{
                            cursor: "pointer",
                          }}
                          // disabled={
                          //   this.state.disabled || this.state.isProcessing
                          // }
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.modalHideDefault();
                          }}
                        >
                          CANCEL
                        </button>
                        {"  "}
                        <button
                          style={{
                            cursor: "pointer",
                          }}
                          className="btn btn-lg btn-mw btn-primary"
                          onClick={() => {
                            this.setDefault(this.state.default_id);
                          }}
                          disabled={
                            this.state.disabled || this.state.isProcessing
                          }
                        >
                          <span>MAKE DEFAULT</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* MODAL DEFAULT GROUP END */}
            {/* MODAL UNDEFAULT GROUP START */}
            <div className="modal fade" tabIndex="-1" id="modalDefaultAlertNew">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <a
                    style={{ cursor: "pointer" }}
                    className="close"
                    onClick={() => {
                      this.modalHideDefaultNew();
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-body modal-body-lg text-center">
                    <div className="nk-modal">
                      <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-star bg-success"></em>
                      <h4 className="nk-modal-title">
                        Remove as Default Group?
                      </h4>
                      {this.state.errorMessageDefault !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageDefault}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessageDefault !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageDefault}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div className="nk-modal-text">
                        <div className="caption-text">
                          This group will no longer be the default selection for
                          new users. Are you sure you want to continue?
                        </div>
                      </div>
                      <div className="nk-modal-action">
                        <button
                          style={{
                            cursor: "pointer",
                          }}
                          // disabled={
                          //   this.state.disabled || this.state.isProcessing
                          // }
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.modalHideDefaultNew();
                          }}
                        >
                          CANCEL
                        </button>
                        {"  "}
                        <button
                          style={{
                            cursor: "pointer",
                          }}
                          className="btn btn-lg btn-mw btn-primary"
                          onClick={() => {
                            this.unsetDefault(this.state.default_id);
                          }}
                          disabled={
                            this.state.disabled || this.state.isProcessing
                          }
                        >
                          <span>REMOVE DEFAULT</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* MODAL UNDEFAULT GROUP END */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
    userRoleItems: state.userRoleItems,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
    setLeftMenu: (menuItems) => dispatch(setLeftMenu(menuItems)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SubUserRoles);
